import { useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import Form, {
  Item,
  Label,
  ButtonItem,
  ButtonOptions,
  RequiredRule,
  EmailRule,
} from "devextreme-react/form";
import LoadIndicator from "devextreme-react/load-indicator";

import "./login-form.scss";
import { ApiResponse, verfiyResponse } from "../../types/models/base-model";
import { LoginResponseModel } from "../../types/models/auth/login-response";
import { LanguageModel } from "../../types/models/system/system-models";
import notify from "devextreme/ui/notify";
import { getLocalized } from "../../redux/localization";
import loader, { isLoading } from "../../redux/loader";
import { createRequest } from "../../redux/base/request";
import auth from "../../redux/auth";
import langugeRedux from "../../redux/language";
export const defaultLanguage: LanguageModel = {
  Code: "tr-TR",
  EnumId: "71173a68-8b7c-4560-bbb6-d98d7817b5ac",
  Name: "Turkish",
};

function LoginForm() {
  const history = useHistory();
  const dispatch = useDispatch();
  const strings = useSelector(getLocalized);
  const loading = useSelector(isLoading);
  const formData = useRef<{ email: string; password: string }>({
    email: "",
    password: "",
  });
  const emailEditorOptions = {
    stylingMode: "filled",
    placeholder: strings.getString("email"),
    mode: "email",
    defaultValue: "fgungor@komutteknolojisi.com",
  };
  const passwordEditorOptions = {
    stylingMode: "filled",
    placeholder: strings.getString("password"),
    mode: "password",
    defaultValue: "1q2w3E**",
  };
  const rememberMeEditorOptions = {
    text: strings.getString("remember_me"),
    elementAttr: { class: "form-text" },
  };

  const onSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      await dispatch(loader.actions.showLoader());
      history.push("/#/")
      const response: ApiResponse<LoginResponseModel> = await createRequest({
        url: "api/appuser/login",
        method: "POST",
        body: {
          userName: formData.current.email,
          password: formData.current.password,
        },
      });
      await dispatch(loader.actions.hideLoader());
      if (verfiyResponse(response)) {
        dispatch(auth.actions.setUser(response.Result));
        // const languageResponse: ApiResponse<LanguageModel[]> =
        //   await createRequest({
        //     url: "System/Languages",
        //     method: "GET",
        //   });
        // if (verfiyResponse(languageResponse)) {
        //   dispatch(langugeRedux.actions.setLanguages(languageResponse.Result));
        // }

        dispatch(
          langugeRedux.actions.setLanguages([
            { Name: "Türkçe", EnumId: "1", Code: "tr-TR" },
          ])
        );
        history.push("/#/");
      } else {
        notify(response.Message, "warning", 500);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  // const onCreateAccountClick = useCallback(() => {
  //   history.push("/create-account");
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [history]);

  return (
    <form className={"login-form"} onSubmit={onSubmit}>
      <Form formData={formData.current} disabled={loading}>
        <Item
          dataField={"email"}
          editorType={"dxTextBox"}
          editorOptions={emailEditorOptions}
        >
          <RequiredRule message={strings.getString("required")} />
          <EmailRule message={strings.getString("email")} />
          <Label visible={false} />
        </Item>
        <Item
          dataField={"password"}
          editorType={"dxTextBox"}
          editorOptions={passwordEditorOptions}
        >
          <RequiredRule message={strings.getString("required")} />
          <Label visible={false} />
        </Item>
        <Item
          dataField={"rememberMe"}
          editorType={"dxCheckBox"}
          editorOptions={rememberMeEditorOptions}
        >
          <Label visible={false} />
        </Item>
        <ButtonItem>
          <ButtonOptions
            width={"100%"}
            type={"default"}
            useSubmitBehavior={true}
          >
            <span className="dx-button-text">
              {loading ? (
                <LoadIndicator width={"24px"} height={"24px"} visible={true} />
              ) : (
                strings.getString("signin")
              )}
            </span>
          </ButtonOptions>
        </ButtonItem>
        <Item>
          <div className={"link"}>
            <Link to={"/reset-password"}>
              {strings.getString("forgot_password")}
            </Link>
          </div>
        </Item>
        {/* <ButtonItem>
          <ButtonOptions
            text={"Create an account"}
            width={"100%"}
            onClick={onCreateAccountClick}
          />
        </ButtonItem> */}
      </Form>
    </form>
  );
}

export default LoginForm;
